import { useState } from "react";
import { localDate } from "@/lib/api";

const PRESETS = [
  { id: "today", label: "Today" },
  { id: "yesterday", label: "Yesterday" },
  { id: "month", label: "This month" },
  { id: "custom", label: "Custom" },
];

const presetRange = (id) => {
  const now = new Date();
  if (id === "yesterday") {
    const y = localDate(new Date(now.getFullYear(), now.getMonth(), now.getDate() - 1));
    return { from: y, to: y };
  }
  if (id === "month") return { from: localDate(new Date(now.getFullYear(), now.getMonth(), 1)), to: localDate(now) };
  return { from: localDate(now), to: localDate(now) };
};

export const fmtDay = (d) => new Date(`${d}T00:00:00`).toLocaleDateString(undefined, { day: "2-digit", month: "short", year: "numeric" });
export const periodLabel = (p) => (p.from === p.to ? fmtDay(p.from) : `${fmtDay(p.from)} – ${fmtDay(p.to)}`);

export function usePeriod() {
  const [period, setPeriod] = useState(() => ({ preset: "today", ...presetRange("today") }));
  return [period, setPeriod];
}

export default function PeriodPicker({ value, onChange, testid = "period" }) {
  const pick = (id) => onChange(id === "custom" ? { ...value, preset: id } : { preset: id, ...presetRange(id) });
  const setDate = (key, v) => {
    if (!v) return;
    const next = { ...value, preset: "custom", [key]: v };
    if (next.from > next.to) key === "from" ? (next.to = v) : (next.from = v);
    onChange(next);
  };
  const today = localDate();
  return (
    <div className="flex items-center gap-2 flex-wrap" data-testid={`${testid}-picker`}>
      <div className="flex items-center gap-1 border border-border bg-card p-1">
        {PRESETS.map((p) => (
          <button key={p.id} data-testid={`${testid}-${p.id}`} onClick={() => pick(p.id)}
            className={`px-3 py-1.5 text-sm font-semibold transition-colors ${value.preset === p.id ? "bg-primary text-primary-foreground" : "text-muted-foreground hover:text-foreground"}`}>
            {p.label}
          </button>
        ))}
      </div>
      {value.preset === "custom" && (
        <div className="flex items-center gap-1.5 text-sm font-semibold">
          <input data-testid={`${testid}-from`} type="date" value={value.from} max={today} onChange={(e) => setDate("from", e.target.value)}
            className="bg-card border border-border px-2.5 py-2" />
          <span className="text-muted-foreground">to</span>
          <input data-testid={`${testid}-to`} type="date" value={value.to} max={today} onChange={(e) => setDate("to", e.target.value)}
            className="bg-card border border-border px-2.5 py-2" />
        </div>
      )}
    </div>
  );
}
